'use client';

import { css, cx } from '@repo/pandacss/styled-system/css';
import { MdArrowUpward, MdVerticalAlignTop } from 'react-icons/md';

type Props = {
  arrowStyle?: 'simple' | 'fancy';
  scrollBehavior?: 'auto' | 'smooth';
  className?: string;
};

const linkClassName = css({
  width: 'fit',
  color: 'secondary',
  alignItems: 'center',
  display: 'flex',
  columnGap: '1',
  rowGap: '1',
  textDecorationLine: 'none',
  cursor: 'pointer',
  _hover: {
    textDecorationLine: 'underline',
  },
});

export function BackToTop({ arrowStyle = 'simple', scrollBehavior = 'smooth', className }: Props) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: scrollBehavior });
  };

  return (
    <a href="#" className={cx(linkClassName, className)} onClick={handleClick}>
      {arrowStyle === 'simple' && <MdArrowUpward size={16} />}
      <span
        className={css({
          textStyle: 'text',
        })}
      >
        Back to top
      </span>
      {arrowStyle === 'fancy' && <MdVerticalAlignTop size={16} />}
    </a>
  );
}
